import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContestReducers } from 'src/app/core/state/app.reducers';
import { ContestState } from './contest.state';

const selectContestsState = createFeatureSelector<ContestState>(ContestReducers.TAG);

export const selectData = createSelector(selectContestsState, (state) => state.data);
export const selectPages = createSelector(selectContestsState, (state) => state.pages);
export const selectPagedData = createSelector(selectData, selectPages, (data, pages) => ({ ...data, pages }));
export const selectGridSearch = createSelector(selectContestsState, (state) => state.gridSearch);
export const selectStatus = createSelector(selectContestsState, (state) => state.status);
export const selectSort = createSelector(selectContestsState, (state) => state.sort);
export const selectCachedPages = createSelector(selectContestsState, (state) => state.cachedPages);
